<template>
    <div class="client-service-assignments">
        <el-button size="small" style="margin-bottom: 25px;" type="primary" @click="createNew">{{ $t('Yeni_təyinat') }}</el-button>
        <el-table :data="assignments" style="width: 100%" v-loading="loadingTable">
            <el-table-column prop="userName" :label="$t('A.S.A')" width="200"></el-table-column>
            <el-table-column prop="policyTypeName" :label="$t('Sığorta_növü')" width="200"></el-table-column>
            <el-table-column prop="insuranceTypeName" :label="$t('Şəhadətnamə_növü')" width="200"></el-table-column>
            <el-table-column prop="personTypeName" :label="$t('Şəxs_növü')" width="200"></el-table-column>
            <el-table-column prop="region" :label="$t('Region')" width="200"></el-table-column>
            <el-table-column :label="$t('Status')" width="120">
                <template slot-scope="scope">
                    <el-switch disabled v-model="scope.row.isActive" 
                        active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </template>
            </el-table-column>
            <el-table-column align="right" fixed="right" width="50">
                <template slot-scope="scope">
                    <el-dropdown trigger="click">
                        <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                            <div class="square-icon">
                                <i class="fas fa-ellipsis-h" :title="$t('Əməliyyatlar')" style="color: #808080;"></i>
                            </div>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="editAssignment(scope.row)">
                                <i class="fa-solid fa-pen-to-square"></i>{{ $t('Düzəliş') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="deleteAssignment(scope.row)">
                                <i class="fa-solid fa-trash"></i>{{ $t('Sil') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        
        <el-dialog :title="mode === 'New' ? $t('Yeni_təyinat') : $t('Təyinatı_düzəliş')" :visible.sync="dialogVisible" width="40%" v-loading="loading">
            <el-form ref="assignmentForm" :model="item" label-width="150px" :label-position="labelPosition" size="small"
                :rules="rules">
                <div class="row">
                    <div class="col-12">
                        <el-form-item :label="$t('İcraçı')" prop="uid">
                            <client-service-user v-model="item.uid" @refresh-table="getData" ref="user" />
                        </el-form-item>
                        <el-form-item :label="$t('Sığorta_növü')" prop="policyType">
                            <policy-types v-model="item.policyType" :type="selectedType" @policytype="item.policyTypeName = $event" :show-all="true" :all-label="$t('Bütün')" />
                        </el-form-item>
                        <el-form-item :label="$t('Şəhadətnamə_növü')" prop="insuranceType">
                            <el-select :placeholder="$t('Seçin')" v-model="item.insuranceType" style="width: 100%">
                                <el-option :label="$t('Bütün')" :value="null"></el-option>
                                <el-option :label="$t('İcbari')" :value="1"></el-option>
                                <el-option :placeholder="$t('Seçin')" :label="$t('Kasko')" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Şəxs_növü')" prop="personType">
                            <el-select :placeholder="$t('Seçin')" v-model="item.personType" style="width: 100%">
                                <el-option :label="$t('Bütün')" :value="null"></el-option>
                                <el-option :label="$t('Fiziki_şəxs')" :value="1"></el-option>
                                <el-option :label="$t('Hüquqi_şəxs')" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Region')" prop="region">
                            <el-select :placeholder="$t('Seçin')" v-model="item.region" style="width: 100%">
                                <el-option :label="$t('Bütün')" :value="null"></el-option>
                                <el-option :label="$t('Bakı')" value="Bakı"></el-option>
                                <el-option :label="$t('Naxçıvan')" value="Naxçıvan"></el-option>
                                <el-option :label="$t('Region_label')" value="Region"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Status')">
                            <el-switch v-model="item.isActive" 
                                active-color="#13ce66" 
                                inactive-color="#ff4949">
                            </el-switch>
                        </el-form-item>
                        <el-form-item class="text-right">
                            <el-button size="small" type="primary" @click="submitForm">{{ $t('Yadda_saxla') }}</el-button>
                            <el-button size="small" @click="dialogVisible = false">{{ $t('İmtina') }}</el-button>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import { 
        CreateClientServiceAssignment, 
        UpdateClientServiceAssignment, 
        GetClientServiceAssignments, 
        DeleteClientServiceAssignment 
    } from "../../services/cls";
    import { labelPosition } from "../../services/helper";
    import ClientServiceUser from "../components/ClientServiceUsers.vue";
    import PolicyTypes from "../components/PolicyTypes.vue";
    
    export default {
        data() {
            return {
                loading: false,
                loadingTable: false,
                dialogVisible: false,
                assignments: [],
                item: {
                    id: null,
                    uid: null,
                    policyType: null,
                    policyTypeName: '',
                    insuranceType: null,
                    insuranceTypeName: '',
                    personType: null,
                    personTypeName: '',
                    region: null,
                    isActive: true,
                },
                mode: "New",
                uid: this.$store.state.user.id,
                selectedType: 0,
                rules: {
                    uid: [{ required: true, message: this.$t('Sütun_mütləqdir_1'), trigger: "change" }],
                },
                labelPosition: labelPosition,
            };
        },
        components: {
            ClientServiceUser,
            PolicyTypes
        },
        methods: {
            createNew() {
                this.resetItem();
                this.mode = "New";
                this.dialogVisible = true;
                this.$nextTick(() => {
                    if (this.$refs.assignmentForm) {
                        this.$refs.assignmentForm.clearValidate();
                    }
                });
            },
            editAssignment(assignment) {
                this.item = { 
                    ...assignment, 
                    isActive: assignment.isActive, 
                    insuranceType: assignment.insuranceType === 1 || assignment.insuranceType === 2 ? assignment.insuranceType : null,
                    personType: assignment.personType === 1 || assignment.personType === 2 ? assignment.personType : null,
                    region: assignment.region || null,
                };

                this.mode = "Edit";
                this.dialogVisible = true;

                this.$nextTick(() => {
                    if (this.$refs.assignmentForm) {
                        this.$refs.assignmentForm.clearValidate();
                    }
                });
            },
            deleteAssignment(assignment) {
                this.$confirm(this.$t('Bu_təyinatı_silmək_istədiyinizə_əminsiniz'), this.$t('Xəbərdarlıq'), {
                    confirmButtonText: this.$t('Bəli'),
                    cancelButtonText: 'Xeyr',
                    type: 'warning'
                }).then(() => {
                    DeleteClientServiceAssignment(assignment.id, this.uid).then((response) => {
                        if (response.data.isSuccess) {
                            this.fetchAssignments();
                            this.$message({
                                type: 'success',
                                message: 'Silindi'
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: response.data.errors[0] || this.$t('Səhv_əməliyyat')
                            });
                        }
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: 'Xəta baş verdi: ' + error.message
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('Silinmə_ləğv_edildi')
                    });
                });
            },
            fetchAssignments() {
                this.loadingTable = true;
                GetClientServiceAssignments().then(response => {
                    if (response.data.data) {
                        this.assignments = response.data.data.map(item => ({
                            ...item,
                            isActive: item.isActive === 1 
                        }));
                    } else {
                        this.assignments = [];
                    }
                }).catch(error => {
                    this.$message.error("Xəta baş verdi: " + error.message);
                }).finally(() => {
                    this.loadingTable = false;
                });
            },
            submitForm() {
                this.$refs.assignmentForm.validate(valid => {
                    if (valid) {
                        this.item.id ? this.updateAssignment() : this.saveAssignment();
                    } else {
                        this.$message({ type: "error", message: this.$t('Mütləq_sütunları_doldurun') });
                    }
                });
            },
            saveAssignment() {
                this.loading = true;
                const assignmentData = {
                    uid: this.item.uid,
                    policyType: this.item.policyType,
                    insuranceType: this.item.insuranceType,
                    personType: this.item.personType,
                    region: this.item.region,
                    isActive: this.item.isActive ? 1 : 0,
                    commandUserId: this.uid
                };
                
                CreateClientServiceAssignment(assignmentData).then((response) => {
                    if (response.data.isSuccess) {
                        this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat_5') });
                        this.dialogVisible = false;
                        this.fetchAssignments();
                    } else {
                        this.$message({ type: "error", message: response.data.errors[0] || this.$t('Xəta_baş_verdi') });
                    }
                }).catch(error => {
                    this.$message({ type: "error", message: "Xəta baş verdi: " + error.message });
                }).finally(() => {
                    this.loading = false;
                });
            },
            updateAssignment() {
                this.loading = true;
                const assignmentData = {
                    id: this.item.id,
                    uid: this.item.uid,
                    policyType: this.item.policyType,
                    insuranceType: this.item.insuranceType,
                    personType: this.item.personType,
                    region: this.item.region,
                    isActive: this.item.isActive ? 1 : 0,
                    commandUserId: this.uid
                };
                
                UpdateClientServiceAssignment(assignmentData).then((response) => {
                    if (response.data.isSuccess) {
                        this.$message({ type: "success", message: this.$t('Təyinat_uğurla_yeniləndi') });
                        this.dialogVisible = false;
                        this.fetchAssignments();
                    } else {
                        this.$message({ type: "error", message: response.data.errors[0] || this.$t('Əməliyyat_Xətası') });
                    }
                }).catch(error => {
                    let errorMessage = "Xəta baş verdi: " + (error.message || this.$t('Bilinməyən_Xəta'));
                    if (error.response) {
                        const data = error.response.data;
                        if (data && Array.isArray(data.errors) && data.errors.length > 0) {
                            errorMessage = data.errors[0];
                        } else if (typeof data === 'string' && data.length > 0) {
                            errorMessage = data;
                        } else if (error.response.status) {
                            errorMessage = `Server Xətası: Status ${error.response.status}. Məlumat yoxdur.`;
                        }
                    }
                    this.$message({ type: "error", message: errorMessage });
                }).finally(() => {
                    this.loading = false;
                });
            },
            resetItem() {
                this.item = {
                    id: null,
                    uid: null,
                    policyType: null,
                    policyTypeName: '',
                    insuranceType: null,
                    insuranceTypeName: '',
                    personType: null,
                    personTypeName: '',
                    region: null,
                    isActive: true,
                };
            },
            getData() {
                this.fetchAssignments();
            }
        },
        watch: {
            dialogVisible(newValue) {
                if (!newValue) {
                    this.resetItem();
                    if (this.$refs.assignmentForm) {
                        this.$refs.assignmentForm.resetFields();
                    }
                }
            }
        },
        mounted() {
            this.fetchAssignments();
        }
    };
</script>

<style scoped>
</style>